import * as React from 'react';

import type { WithStyles } from '@material-ui/styles';
import { withStyles } from '@material-ui/styles';
import { action, computed, observable } from 'mobx';
import { inject, observer } from 'mobx-react';

import type ProviderStore from 'connect/web/src/stores/provider-store';
import styles from './styles';

import { Button, SwipeableDrawer } from '@material-ui/core';
import { cache } from 'tm3-core/cache';

interface IProps extends WithStyles<typeof styles> {
  providerStore?: ProviderStore;
}

@inject('providerStore')
@observer
class GdprCookie extends React.Component<IProps> {
  @observable show = false;

  constructor(props: IProps) {
    super(props);

    setTimeout(() => {
      const cookies = document.cookie.split(';');

      const consentCookie = cookies.find((cookie) => {
        return cookie.trim() === 'connectGdprConsent=true';
      });

      this.show = consentCookie == null;
    }, 3000);
  }

  render() {
    const { classes, providerStore } = this.props;
    const { accept, dialog, grid, title } = classes;

    const baseUrl = cache.helpUrl;

    if (providerStore!.embeddedMode) {
      return null;
    }

    return (
      <SwipeableDrawer
        anchor="bottom"
        open={this.show}
        variant="persistent"
        onClose={Function.NOOP}
        onOpen={Function.NOOP}
      >
        <div className={dialog}>
          <div className={'container'}>
            <h2 className={title}>What do we use cookies for?</h2>
            <div className={grid}>
              <div>
                {this.message}{' '}
                <a target="_blank" href={`${baseUrl}/en/articles/6444089-tm3-connect-cookies`}>
                  More information
                </a>
              </div>
              <div className={accept}>
                <Button variant="contained" onClick={this.onClickEssential} fullWidth={false}>
                  Accept essential cookies only
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onClick}
                  fullWidth={false}
                >
                  Accept all cookies
                </Button>
              </div>
            </div>
          </div>
        </div>
      </SwipeableDrawer>
    );
  }

  @computed
  private get message(): string {
    const { analyticsEnabled } = this.props.providerStore!;

    let message =
      'This site, like most other sites on the internet, uses cookies. A cookie is a small bit of text stored in your browser that we use to identify you when you sign in and allow the use of essentail functions on this site.';

    if (analyticsEnabled) {
      message += ' We also use non-essential cookies for analytics, which you may refuse.';
    }

    return message;
  }

  @action.bound
  private onClick(): void {
    document.cookie = 'connectGdprConsent=true;max-age=31536000';
    this.props.providerStore!.enableAnalytics();
    this.show = false;
  }

  @action.bound
  private onClickEssential(): void {
    document.cookie = 'connectGdprConsent=true;max-age=31536000';
    document.cookie = 'connectGdprEssentialOnly=true;max-age=31536000';
    this.props.providerStore!.disableAnalytics();
    this.show = false;
  }
}

export default withStyles(styles)(GdprCookie);
